import React, { useState } from "react";
import {
  MapPinIcon,
  CheckCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { toast } from "react-toastify";
import CustomProfessionDropdown from "../../../../dropdown/CustomProfessionDropDown";
import CustomInputField from "../../../../customInputField";
import RangeSlider from "../../../../rangeSlider";
import DeleteRegionModal from "../../../../modal/DeleteRegionModal";
import IconButton from "../../../../iconButton";

const ProfessionalRegionFields = ({
  region,
  handleInputChange,
  handleSelectedPlan,
  saveRegion,
  title,
  isNewRegion,
  unit,
  handleDelete,
  regionsLength,
  hasChanges,
  handleSave,
  professionNames,
  selectedProfessionOption,
  setSelectedProfessionOption,
  loader,
}) => {
  const rangeItems = ["5","10", "15", "25", "35", "45", "55", "75"];
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDeleteModal = () => {
    if (regionsLength == 1) {
      toast.error(
        "You must have at least one region active in your account. To delete this region, please add a new region first."
      );
    } else {
      setShowDeleteModal(true);
    }
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  const handleRegionDelete = () => {
    setShowDeleteModal(false);
    handleDelete(region.id);
  };

  return (
    <div>
      <div id="parentContainer">
        <div id="upperDiv">
          <div>
            <div className="hidden md:flex justify-between mb-2">
              <div className="flex items-start md:items-center gap-2 max-w-[300px] w-full flex-col md:flex-row">
                {region?.profession?.name ? (
                  <span className="location-span text-xs font-bold leading-[160%] uppercase text-[#869099] mb-2 inline-block">
                    Location {title}: {region?.profession?.name ?? ""}
                  </span>
                ) : (
                  <span className="w-20 location-span text-xs font-bold leading-[160%] uppercase text-[#869099] mb-2 inline-block">
                    Add New
                  </span>
                )}
                {!region?.profession?.name && (
                  <CustomProfessionDropdown
                    options={professionNames}
                    classes="px-[14px] md:p-5 border border-solid border-[#EBEFF3] rounded-[10px] h-12 bg-white flex items-center justify-between"
                    textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-base font-medium text-customGray"
                    rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
                    menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    selectedOption={selectedProfessionOption}
                    setSelectedOption={setSelectedProfessionOption}
                  />
                )}
              </div>
              <div className="flex items-center justify-end min-w-[150px] gap-2">
                {hasChanges && (
                  <IconButton
                    title="Save"
                    icon={CheckCircleIcon}
                    iconClasses="w-6 h-6 text-white"
                    classes={`text-sm font-black leading-[160%] text-white max-w-[160px] md:max-w-[128px] w-full flex items-center justify-center gap-[6px] bg-primary h-10 rounded-[10px] cursor-pointer opacity-1 ${
                      loader && "pointer-events-none"
                    }`}
                    onClick={() => handleSave(region)}
                    buttonLoader={loader}
                  />
                )}
                {!isNewRegion && (
                  <span className="cursor-pointer">
                    <XMarkIcon
                      className="w-5 h-5 hover:text-red-500"
                      aria-hidden="true"
                      onClick={handleDeleteModal}
                    />
                  </span>
                )}
              </div>
            </div>
            <div className="flex md:hidden justify-between flex-col mb-2">
              <div className="flex items-center gap-2 w-full mb-2">
                {region?.profession?.name ? (
                  <span className="location-span text-xs font-bold leading-[160%] uppercase text-[#869099] mb-2 inline-block">
                    Location {title}: {region?.profession?.name ?? ""}
                  </span>
                ) : (
                  <span className="w-20 location-span text-xs font-bold leading-[160%] uppercase text-[#869099] mb-2 inline-block">
                    Add New
                  </span>
                )}
                {!region?.profession?.name && (
                  <CustomProfessionDropdown
                    options={professionNames}
                    classes="px-[14px] md:p-5 border border-solid border-[#EBEFF3] rounded-[10px] h-12 bg-white flex items-center justify-between"
                    textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-base font-medium text-customGray"
                    rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
                    menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    selectedOption={selectedProfessionOption}
                    setSelectedOption={setSelectedProfessionOption}
                  />
                )}
              </div>
              <div className="flex items-center justify-end min-w-[150px] gap-2">
                {hasChanges && (
                  <IconButton
                    title="Save"
                    icon={CheckCircleIcon}
                    iconClasses="w-6 h-6 text-white"
                    classes={`text-sm font-black leading-[160%] text-white max-w-[160px] md:max-w-[128px] w-full flex items-center justify-center gap-[6px] bg-primary h-10 rounded-[10px] cursor-pointer opacity-1 ${
                      loader && "pointer-events-none"
                    }`}
                    onClick={() => handleSave(region)}
                    buttonLoader={loader}
                  />
                )}
                {!isNewRegion && (
                  <span className="cursor-pointer">
                    <XMarkIcon
                      className="w-5 h-5 hover:text-red-500"
                      aria-hidden="true"
                      onClick={handleDeleteModal}
                    />
                  </span>
                )}
              </div>
            </div>
            <CustomInputField
              name="zipCode"
              icon={MapPinIcon}
              onChange={(e) => handleInputChange(e)}
              placeHolder={"City or Zip Code"}
              value={region && region.zip_code}
              type="text"
              classes={`flex items-center h-[48px] md:h-[60px] border border-solid border-[#CCD0D4] rounded-[10px] xl:mb-5`}
              inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] pr-[20px] bg-transparent"
              successIcon={
                region &&
                region.zip_code !== "" &&
                saveRegion &&
                !hasChanges &&
                CheckCircleIcon
              }
            />
          </div>
          <div className="grid grid-cols-12 gap-5 pt-5 pb-5 xl:pb-[30px] mb-5 xl:mb-[30px] border-b border-solid border-[#EBEFF3]">
            <h6 className="text-base font-bold leading-[160%] text-[#485868] col-span-12 xl:col-span-3">
              I serve ZIP codes within
            </h6>
            <div className={`col-span-12 xl:col-span-9`}>
              <RangeSlider
                rangeItems={rangeItems}
                handleSelectedPlan={handleSelectedPlan}
                selectedValue={(region && region.miles) ?? "25"}
                unit={unit}
              />
            </div>
          </div>
        </div>
      </div>
      <DeleteRegionModal
        isOpen={showDeleteModal}
        handleClose={handleClose}
        handleDelete={handleRegionDelete}
        text="Do you really want to delete this region?"
        loader={loader}
      />
    </div>
  );
};

export default ProfessionalRegionFields;
